<template>
  <div class="dashboard-design">
    <router-view></router-view>
  </div>
</template>

<script>
import DesignMain from './DesignMain.vue';
import NewDesign from './NewDesign.vue';

export default {
  children: [
    {
      path: '',
      name: 'design-main',
      component: DesignMain
    },
    {
      path: 'new',
      name: 'new-design',
      component: NewDesign
    }
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/design/Design.vue